import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES, SERVICE_ROUTES } from '../data/siteLinks';
import { hasAnalyticsConsent, trackEvent, trackPageView } from '../utils/analytics';

const servicePaths = new Set<string>(Object.values(SERVICE_ROUTES));

const cleanText = (value: string | null | undefined) =>
  (value || '').replace(/\s+/g, ' ').trim().slice(0, 100);

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (hasAnalyticsConsent()) trackPageView();
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as Element | null;
      const link = target?.closest('a');
      if (!link || !hasAnalyticsConsent()) return;

      const url = new URL(link.href, window.location.origin);
      const linkText = cleanText(link.textContent || link.getAttribute('aria-label'));
      const common = {
        link_text: linkText,
        page_path: window.location.pathname,
      };

      if (url.hostname === 'wa.me') {
        if (link.classList.contains('blog-post-share-btn')) {
          trackEvent('share_whatsapp', common);
        } else if (link.classList.contains('randevu-card-btn')) {
          const serviceName = cleanText(link.closest('.randevu-card')?.querySelector('h2')?.textContent);
          trackEvent('appointment_whatsapp_click', { ...common, service_name: serviceName });
        } else if (link.classList.contains('blog-service-transition-whatsapp')) {
          trackEvent('service_whatsapp_click', common);
        } else {
          trackEvent('whatsapp_contact_click', common);
        }
        return;
      }

      if (
        url.origin === window.location.origin &&
        url.pathname === ROUTES.services &&
        url.hash === '#hizmet-ucretleri'
      ) {
        trackEvent('pricing_click', {
          ...common,
          destination: `${url.pathname}${url.hash}`,
        });
        return;
      }

      if (url.origin === window.location.origin && servicePaths.has(url.pathname)) {
        trackEvent('service_page_click', { ...common, destination: url.pathname });
        return;
      }

      if (url.origin === window.location.origin && url.pathname === '/randevu-alin') {
        trackEvent('appointment_page_click', common);
        return;
      }

      if (link.href.startsWith('mailto:')) trackEvent('email_click', common);
      if (link.href.startsWith('tel:')) trackEvent('phone_click', common);
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);

  return null;
};

export default AnalyticsTracker;
